import { call, fetchAllPages } from '../../shared/api.ts'
import type { apiDto } from '@rs/contracts'

/**
 * ══ CỬA GỌI REST — CỔNG THẦU PHỤ ▸ ĐỐI SOÁT (F21) ═════════════════════════════════════════════
 * ⚠ KHÔNG cửa nào nhận `vendorId`: máy chủ lấy nó TỪ PHIÊN. Nếu ngày nào có một tham số như vậy
 *   xuất hiện ở đây thì đó là lỗi, không phải tiện ích.
 */
export type MyApInvoice = apiDto.VendorApInvoiceDto
export type ReconRow = apiDto.ReconRequestDto
export type ReconSummary = apiDto.ReconSummaryDto

const BASE = '/api/v1/ncc/doi-soat'

export const fetchMyApInvoices = (): Promise<{ rows: MyApInvoice[]; summary: ReconSummary }> =>
  call<{ rows: MyApInvoice[]; summary: ReconSummary }>(`${BASE}/chung-tu?limit=200`)

export const ackInvoiceApi = (id: string, version: number): Promise<void> =>
  call<void>(`${BASE}/chung-tu/${id}/xac-nhan`,
    { method: 'POST', body: JSON.stringify({ version }) })

export const fetchMyRecon = (): Promise<ReconRow[]> => fetchAllPages<ReconRow>(BASE)

export const sendReconApi = (body: Record<string, unknown>): Promise<ReconRow> =>
  call<ReconRow>(BASE, { method: 'POST', body: JSON.stringify(body) })
